import { AppRegistry, Alert } from 'react-native';
import App from './App';
import { name as appName } from './app.json';
import './src/web/fonts.css';
import './src/web/vector-icons.css';
import { useGlobalAlertStore } from './src/store/GlobalAlertStore';

Alert.alert = (title, message) => {
  useGlobalAlertStore.getState().show(title, message, 'error');
};

AppRegistry.registerComponent(appName, () => App);

AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});

